import { render, staticRenderFns } from "./Designs.vue?vue&type=template&id=68151758&scoped=true"
import script from "./Designs.vue?vue&type=script&lang=js"
export * from "./Designs.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Designs.vue?vue&type=style&index=0&id=68151758&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "68151758",
  null
  ,true
)

export default component.exports